import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import Home                   from './pages/Home';
import Solutions               from './components/Solution';
import Climatisation           from './pages/Climatisation';
import PompeAChaleur           from './pages/Pompeachaleur';
import Ventilation             from './pages/Ventilation';
import EntretienClimatisation  from './pages/Entretienclimatisation';
import MentionsLegales         from './politique/Mentionslegales';
import PolitiqueConfidentialite from './politique/Politiqueconfidentialite';
import Cgv                     from './politique/Cgv';

export default function App() {
  return (
    <HelmetProvider>
      <Router>
        <Routes>
          {/* Home */}
          <Route path="/"                        element={<Home />} />

          {/* Services */}
          <Route path="/solution"                element={<Solutions />} />
          <Route path="/climatisation"           element={<Climatisation />} />
          <Route path="/pompe-a-chaleur"         element={<PompeAChaleur />} />
          <Route path="/ventilation"             element={<Ventilation />} />
          <Route path="/entretien-climatisation" element={<EntretienClimatisation />} />

          {/* Légal */}
          <Route path="/mentions-legales"        element={<MentionsLegales />} />
          <Route path="/confidentialite"         element={<PolitiqueConfidentialite />} />
          <Route path="/cgv"                     element={<Cgv />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}